export default "__VITE_ASSET__4$Vbe8tS__"